import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrls: ['./home-two.component.scss']
})
export class HomeTwoComponent implements OnInit {
  envName = environment.ENV;

  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'IT Consulting & Intelligent Automation Solutions | DotBlack',
      description: 'Modernise systems, automate operations and deliver technology programmes with DotBlack’s consulting, automation and specialist IT services.',
      path: '/',
      schema: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'DotBlack Projex Pty (Ltd)',
        url: 'https://dotblack.co.za/',
        email: 'mufk@dotblack.co.za',
        telephone: '+27 11 568 5421',
        description: 'DotBlack provides IT consulting, intelligent automation, programme and project management, specialist IT teams and digital solutions.'
      }
    });
  }
}
